import React, { useCallback, useEffect, useState } from "react";
import { PropagateLoader } from "react-spinners";
import { IoMdAdd } from "react-icons/io";
import useModal from "../../../hooks/useModal";
import { GET_CONTRACTS_BY_CLIENT, GET_PAYMENTS_BY_CONTRACT } from "../../../api/apiContratos";
import CardHeader from "../../atoms/CardHeader";
import Breadcrumb from "../../molecules/Breadcrumb";
import CardTables from "../../atoms/CardTables";
import Button from "../../atoms/Button";
import ContratosTable from "../../organisms/contratos/ContratosTable";
import Modal from "../../molecules/Modal";
import ModalCrearContrato from "../../organisms/contratos/ModalCrearContrato";
import { GET_ENTERPRISE_BY_ID } from "../../../api/apiEmpresas";

const ContratosTemplate = ({ clientId }) => {
	const [contratos, setContratos] = useState([]);
	const [loading, setLoading] = useState(false);
	const { open, close, isOpen } = useModal();
    const [enterprise, setEnterprise] = useState(null);

    const fetchEnterprise = useCallback(async () => {
        try {
            const enterpriseData = await GET_ENTERPRISE_BY_ID(clientId);
            setEnterprise(enterpriseData);
        } catch (error) {
            console.error("Error al obtener datos de la empresa:", error);
        }
    },[clientId]);

	const getContratos = useCallback(async () => {
		setLoading(true);
		try {
			const contratosData = await GET_CONTRACTS_BY_CLIENT(clientId);
			
			const contratosConPagos = await Promise.all(
				contratosData.map(async (contrato) => {
					try {
						const pagos = await GET_PAYMENTS_BY_CONTRACT(contrato.id);
						return {
							...contrato,
							pagos: pagos || [],
						};
					} catch (error) {
						console.error(`Error al obtener pagos del contrato ${contrato.id}:`, error);
						return {
							...contrato,
							pagos: [],
						};
					}
				})
			);

			setContratos(contratosConPagos);
		} catch (error) {
			console.error("Error al obtener contratos:", error);
		} finally {
			setLoading(false);
		}
	}, [clientId]);

	useEffect(() => {
		getContratos();
	}, [getContratos]);

    useEffect(() => {
        fetchEnterprise();
    },[fetchEnterprise]);

	return (
		<div className="space-y-2">
			<CardHeader>
				<Breadcrumb
					items={[
						{ label: "Inicio", to: "/dashboard" },
						{ label: `${enterprise ? enterprise.name : "Cargando..."}` , to: `/clientes/empresas/${enterprise?.id || clientId}/decide` },
						{ label: "Contratos", to: null },
					]}
				/>
			</CardHeader>

			<CardTables>
				<div className="flex justify-end mb-4">
					<Button
						text={<div className="flex items-center gap-2"><IoMdAdd size={20} /> Nuevo Contrato</div>}
						bgColor="blue"
						onClick={open}
					/>
				</div>
				{loading ? (
					<div className="w-full flex justify-center items-center h-32">
						<PropagateLoader color="red" />
					</div>
				) : (
					<ContratosTable data={contratos} refetch={getContratos} />
				)}
			</CardTables>

			{isOpen && enterprise && (
				<Modal onClose={close} title="Crear Nuevo Contrato">
					<ModalCrearContrato
						clientId={clientId}
                        userId={enterprise?.userId}
						onClose={close}
						refetch={getContratos}
					/>
				</Modal>
			)}
		</div>
	);
};

export default ContratosTemplate;